import TreeMarker from "@/assets/MapIcons/woods-marker.svg";
import FlagMarker from "@/assets/MapIcons/flag-marker.svg";
import OutlineMarker from "@/assets/MapIcons/outline-marker.svg";

const barrierTypes = [
  {
    name: "Tree",
    type: 1,
    iconURL: TreeMarker,
    iconSize: [32, 32],
    cost: 100
  },
  {
    name: "Bush",
    type: 2,
    iconURL: FlagMarker,
    iconSize: [32, 32],
    cost: 50
  },
  {
    name: "Wall",
    type: 3,
    iconURL: OutlineMarker,
    iconSize: [32, 32],
    cost: 1000
  }
];

export default barrierTypes;
